$(document).ready(function () {
  demoPopup();
});

function demoPopup() {
  if ($(".popup--subscribe").length > 0) {
    var popup = $(".popup--subscribe").first();

    $(".c-footer-signup").click(function () {
      popup.removeClass('hide');
      popup.fadeIn(100);
    });

    popup.find(".popup_close").click(function () {      
      ClosePopup(popup);
    });
  }
}

function ClosePopup(popup) {
  popup.fadeOut(100);
  popup.addClass('hide');
  $("body").css("overflow-y", "auto");
}
